export const VehicleOption = Object.freeze({
  AC: {
    value: 'airConditioning',
    label: 'Climatisation',
    icon: '❄️',
  },
  TOILET: {
    value: 'toilet',
    label: 'Toilettes',
    icon: '🚻',
  },
  TV: {
    value: 'tv',
    label: 'Télévision',
    icon: '📺',
  },
  CATERING: {
    value: 'refreshments',
    label: 'Restauration',
    icon: '🍽️',
  },
  WIFI: {
    value: 'wifi',
    label: 'Wi-Fi',
    icon: '🛜',
  },

})

// Liste à plat pour les v-for
export const VEHICLE_OPTIONS = Object.values(VehicleOption)

// Résout un tableau de valeurs brutes → objets complets
export function resolveVehicleOptions(values = []) {
  if (!Array.isArray(values)) return []
  return VEHICLE_OPTIONS.filter(opt => values.includes(opt.value))
}
